import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic';
import { UIButtons } from '@gongxigames/framework/slot/types';
import { ReelsEvents } from '@gongxigames/framework/slot/modules/reels';
import {
    IPromotionLogic,
    GameSessionPromotionEvents,
    GameSessionPromotionModule,
    GameSessionPromotionStates,
} from '@gongxigames/framework/promotions';

export class GameSessionPromotionInProgressState extends ModuleState<null, GameSessionPromotionModule, GameSessionPromotionEvents> {
    private isFinished = false;

    public onEnterState(): void {
        this.isFinished = false;
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted.bind(this));
        this.setEventHandler(ReelsEvents.SPIN_ENDED, this.onSpinEnded.bind(this));
        this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.onPaidRoundEnded.bind(this));
        this.setEventHandler(LogicEvents.RESPONSE, this.onResponse.bind(this));
    }

    private onResponse(): void {
        if (this.promotion.isEndOfPromotion()) {
            this.emit('General.Slot.SPIN.DISABLE', GameSessionPromotionModule.NAME);
        }
    }

    private onSpinStarted(): void {
        if (this.promotion.isNextPromotion()) {
            this.promotion.subtractPromotion();
            this.module.updateCounter();
        }
    }
    private onSpinEnded(): void {
        if (this.promotion.isLastPromotion()) {
            this.emit('Autoplay.STOP');
            this.emit('General.UI.Button.ENABLE', { name: UIButtons.AUTOPLAY, reason: GameSessionPromotionModule.NAME });
        }
    }

    private onPaidRoundEnded(): void {
        if (this.promotion.isEndOfPromotion() && !this.isFinished) {
            this.isFinished = true;
            this.module.gotoState(GameSessionPromotionStates.END);
        }
    }
    public onLeaveState(): void {}

    private get promotion(): IPromotionLogic {
        return this.module.getPromotion();
    }
}
